import React from 'react';
import { FlexyButton, useModal } from '@europrocurement/flexy-components';
import { Typography, useTheme } from '@mui/material';
import { Box } from '@mui/system';

export type ValidationModalProps = {
    title?: string;
    message?: string;
    confirmationLabel?: string;
    cancellationLabel?: string;
    onSubmit: () => void;
    isDestructive?: boolean;
};

/**
 * validation modal with 'Annuler' & 'Valider' buttons. Annuler close modal, Valider strike the function passed in params
 * @param message message string to display in the modal. Default :  'Êtes-vous sûr de vouloir valider cette action ?'
 * @returns strike the function passed in parameters
 */
export const ValidationModal: React.FunctionComponent<ValidationModalProps> = function ({
    title,
    message,
    confirmationLabel = 'Valider',
    cancellationLabel = 'Annuler',
    onSubmit,
    isDestructive = false,
}) {
    const { modalActions } = useModal();
    const { palette } = useTheme();

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        onSubmit();
    };

    return (
        <form onSubmit={(e) => handleSubmit(e)}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'start',
                    justifyContent: 'space-between',
                    minHeight: '250px',
                }}
            >
                <Typography
                    variant="l2dh4"
                    style={{ marginBottom: '8px' }}
                >
                    {title || "Confirmation de l'action"}
                </Typography>
                <Typography
                    variant="l2dbodym"
                    style={{ marginBottom: '8px' }}
                >
                    {message || 'Êtes-vous sûr de vouloir valider cette action ?'}
                </Typography>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="space-evenly"
                    sx={{
                        width: '100%',
                        gap: 2,
                    }}
                >
                    <FlexyButton
                        label={confirmationLabel}
                        color={isDestructive ? palette.error.main : palette.primary.dark}
                        variant="contained"
                        type="submit"
                        style={{ marginTop: '8px', marginBottom: '8px', width: '100%' }}
                    />

                    <FlexyButton
                        label={cancellationLabel}
                        color={palette.primary.dark}
                        variant="outlined"
                        onClick={() => modalActions.close()}
                        style={{ marginTop: '8px', marginBottom: '8px', width: '100%' }}
                    />
                </Box>
            </Box>
        </form>
    );
};
